export enum Steps {
  DETAILS = 'Professional details',
  COMPANY_CONTACTS = 'Company contacts',
  BILLING = 'Billing',
  REVIEW = 'Review and confirm',
  CONFIRM = 'Confirm',
}
